import { omit } from 'lodash-es';

import { useAllObjectClassListQuery, useTaskUpdateQuery } from '@/hook';
import { Edit, VButton, VFlex } from '@/package';
import type { Task } from '@/type';

import { TaskCreateForm } from '../Task';

export const TaskOverviewEdit = ({ taskDetail }: { taskDetail: Task }) => {
  const { mutate: updateTask } = useTaskUpdateQuery();
  const { data: allObjectClassList } = useAllObjectClassListQuery();

  return (
    <div className="size-full w-[972px] overflow-x-hidden overflow-y-hidden pt-4">
      <div className="size-full overflow-x-hidden overflow-y-auto pb-10">
        {taskDetail && allObjectClassList && (
          <TaskCreateForm
            key={taskDetail.updatedAt}
            renderFooter={methods => {
              const onClick = () => {
                const { distance } = methods.getValues();
                const { startDate, dueDate } = methods.getValues();
                updateTask({
                  ...omit(taskDetail, ['extendClass', 'classConfidence']),
                  ...omit(methods.getValues(), ['classConfidence']),
                  classConfidence: {
                    confidence:
                      methods.getValues('classConfidence')?.map(item => ({
                        id: item.id,
                        confidence: Number(item.confidence),
                      })) ?? [],
                  },
                  distance: Number(distance),
                  workFrameInterval: Number(taskDetail.workFrameInterval),
                  pTaskID: taskDetail.id,
                  projectID: taskDetail.projectID,
                  startDate: startDate ? `${startDate}` : '',
                  dueDate: dueDate ? `${dueDate}` : '',
                });
              };

              const isTouched = methods.formState.isDirty;

              return (
                <VFlex className="w-full" justify="end">
                  <VButton
                    className="w-[478px]"
                    onClick={onClick}
                    type="button"
                    disabled={!isTouched}
                  >
                    <Edit />
                    Edit
                  </VButton>
                </VFlex>
              );
            }}
            defaultValue={{
              ...taskDetail,
              worker: taskDetail.userTask
                ?.map(userTask => userTask.user)
                .filter(user => !!user),
              classConfidence:
                taskDetail.classConfidence?.confidence?.map(item => ({
                  id: item.id,
                  confidence: Number(item.confidence),
                  classType:
                    allObjectClassList.find(cls => cls.id === item.id)
                      ?.classType ?? 'Super',
                })) ?? [],
            }}
            readOnlyField={{
              classConfidence: true,
              distance: true,
              taskFolder: true,
              workFrameInterval: true,
              worker: true,
            }}
          />
        )}
      </div>
    </div>
  );
};
